module.exports = __webpack_public_path__ + "img/img38.c2300866.png";